module.exports = __webpack_public_path__ + "static/media/step-indicator-2.cdec3f70.svg";